export var ResponseType;
(function (ResponseType) {
    ResponseType["None"] = "None";
    ResponseType["Organizer"] = "Organizer";
    ResponseType["TentativelyAccepted"] = "TentativelyAccepted";
    ResponseType["Accepted"] = "Accepted";
    ResponseType["Declined"] = "Declined";
    ResponseType["NotResponded"] = "NotResponded";
})(ResponseType || (ResponseType = {}));
export var RecommendedCardType;
(function (RecommendedCardType) {
    RecommendedCardType["SuggestedTask"] = "SuggestedTask";
    RecommendedCardType["UpcomingMeeting"] = "UpcomingMeeting";
    RecommendedCardType["CompositeCard"] = "CompositeCard";
    RecommendedCardType["FocusTime"] = "FocusTime";
    RecommendedCardType["File"] = "File";
})(RecommendedCardType || (RecommendedCardType = {}));
export var ActionType;
(function (ActionType) {
    /// <summary>
    /// Unknown action.
    /// </summary>
    ActionType["Unknown"] = "Unknown";
    /// <summary>
    /// Action representing a commitment.
    /// </summary>
    ActionType["Commitment"] = "Commitment";
    /// <summary>
    /// Action representing a request.
    /// </summary>
    ActionType["Request"] = "Request";
    /// <summary>
    /// Action representing a follow-up.
    /// </summary>
    ActionType["FollowUp"] = "FollowUp";
    /// <summary>
    /// Action representing a follow-up action request.
    /// </summary>
    ActionType["FollowUpActionRequest"] = "FollowUpActionRequest";
    /// <summary>
    /// Action representing a follow-up reply request.
    /// </summary>
    ActionType["FollowUpReplyRequest"] = "FollowUpReplyRequest";
    /// <summary>
    /// Action representing an assigned request.
    /// </summary>
    ActionType["AssignedRequest"] = "AssignedRequest";
    /// <summary>
    /// Action representing an Action Request
    /// </summary>
    ActionType["ActionRequest"] = "ActionRequest";
    /// <summary>
    /// Action representing a reply request action request.
    /// </summary>
    ActionType["ReplyRequest"] = "ReplyRequest";
})(ActionType || (ActionType = {}));
export var PotentialActionType;
(function (PotentialActionType) {
    PotentialActionType["MarkTaskAsDone"] = "MarkTaskAsDone";
    PotentialActionType["MarkAsNotATask"] = "MarkAsNotATask";
    PotentialActionType["PromoteTask"] = "PromoteTask";
    PotentialActionType["DismissAction"] = "DismissAction";
    PotentialActionType["UndoTask"] = "UndoTask";
})(PotentialActionType || (PotentialActionType = {}));
//# sourceMappingURL=RecommendedTypes.js.map